import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';
axios.defaults.withCredentials = true;

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [erreur, setErreur] = useState(null);

  useEffect(() => {
    axios
      .get('/personnel/dashboard/statsparserviceinterne/1/x')
      .then((response) => setStats(response.data))
      .catch((error) => setErreur('Erreur de chargement des stats !'));
  }, []);

  if (!stats) {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center">
        <div className="text-slate-500 text-lg font-semibold animate-pulse">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 px-4 py-10 mt-5">
      <div className="max-w-6xl mx-auto">

        {/* Titre */}
        <div className="text-center mb-8">
          <span className="bg-green-100 text-green-800 text-xs font-bold px-4 py-1 rounded-full uppercase tracking-widest">
            DCCA — Tableau de bord
          </span>
          <h2 className="text-2xl font-bold text-slate-800 mt-3">
            Statistiques Personnel Civil
          </h2>
        </div>

        {erreur && (
          <div className="bg-red-50 text-red-700 border border-red-200 rounded-xl px-4 py-3 mb-6 text-sm">
            {erreur}
          </div>
        )}

        {/* Total général */}
        <div className="bg-slate-800 rounded-2xl p-8 text-center mb-6">
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-2">
            Total des Personnels CIVIL
          </p>
          <div className="text-8xl font-black text-green-400 leading-none">
            {stats.totalCivil}
          </div>
          <p className="text-slate-500 text-sm mt-2">personnels enregistrés</p>
        </div>

        {/* Cartes grades */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-2xl p-6 text-center border-t-4 border-amber-400">
            <p className="text-xs font-bold text-amber-500 uppercase tracking-widest mb-2">Fonctionnaire</p>
            <div className="text-6xl font-black text-slate-800">{stats.grades.FONCTIONNAIRE}</div>
          </div>
          <div className="bg-white rounded-2xl p-6 text-center border-t-4 border-red-500">
            <p className="text-xs font-bold text-red-500 uppercase tracking-widest mb-2">EFA</p>
            <div className="text-6xl font-black text-slate-800">{stats.grades.EFA}</div>
          </div>
          <div className="bg-white rounded-2xl p-6 text-center border-t-4 border-blue-500">
            <p className="text-xs font-bold text-blue-500 uppercase tracking-widest mb-2">ELD</p>
            <div className="text-6xl font-black text-slate-800">{stats.grades.ELD}</div>
          </div>
        </div>

        {/* Tableau */}
        <div className="bg-white rounded-2xl overflow-hidden border border-slate-200 mb-6">
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="bg-slate-800">
                  <th className="px-5 py-4 text-left text-xs font-semibold text-slate-400 uppercase tracking-widest">Etsouservice</th>
                  <th className="px-4 py-4 text-center text-xs font-semibold text-amber-400 uppercase tracking-widest">FONCT.</th>
                  <th className="px-4 py-4 text-center text-xs font-semibold text-red-400 uppercase tracking-widest">EFA</th>
                  <th className="px-4 py-4 text-center text-xs font-semibold text-blue-400 uppercase tracking-widest">ELD</th>
                  <th className="px-4 py-4 text-center text-xs font-semibold text-green-400 uppercase tracking-widest">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(stats.etsouservices).map((nom, index) => (
                  <tr key={nom} className={`border-b border-slate-100 hover:bg-green-50 transition-colors duration-150 ${index % 2 === 0 ? 'bg-white' : 'bg-slate-50'}`}>
                    <td className="px-5 py-3 font-semibold text-slate-800">
                      <span className="inline-block w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                      {nom}
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-full">
                        {stats.etsouservices[nom].FONCTIONNAIRE || '—'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="bg-red-100 text-red-800 text-xs font-bold px-3 py-1 rounded-full">
                        {stats.etsouservices[nom].EFA || '—'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full">
                        {stats.etsouservices[nom].ELD || '—'}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-center">
                      <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full">
                        {stats.etsouservices[nom].TOTAL}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="bg-slate-800">
                  <td className="px-5 py-4 font-bold text-slate-300 uppercase text-xs tracking-widest">Total Général</td>
                  <td className="px-4 py-4 text-center font-bold text-amber-400">{stats.grades.FONCTIONNAIRE}</td>
                  <td className="px-4 py-4 text-center font-bold text-red-400">{stats.grades.EFA}</td>
                  <td className="px-4 py-4 text-center font-bold text-blue-400">{stats.grades.ELD}</td>
                  <td className="px-4 py-4 text-center bg-green-600 font-black text-white text-lg">{stats.totalCivil}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        {/* Sexe + Statut marital */}
        {/* Répartition par sexe */}
        <div className="bg-white rounded-2xl p-5 border border-slate-200">
          <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-4">Répartition par sexe</p>
          <div className="grid grid-cols-3 gap-3">

            <div className="bg-slate-50 rounded-xl p-3 text-center">
              <p className="text-xs font-bold text-slate-500 uppercase mb-2">Grade</p>
              <p className="text-xs font-semibold text-slate-600">FONCTIONNAIRE</p>
              <p className="text-xs font-semibold text-slate-600 mt-1">EFA</p>
              <p className="text-xs font-semibold text-slate-600 mt-1">ELD</p>
            </div>

            <div className="bg-blue-50 rounded-xl p-3 text-center">
              <p className="text-xs font-bold text-blue-700 uppercase mb-2">Homme</p>
              <p className="text-xl font-black text-slate-800">{stats.sexes.M.FONCTIONNAIRE}</p>
              <p className="text-xl font-black text-slate-800">{stats.sexes.M.EFA}</p>
              <p className="text-xl font-black text-slate-800">{stats.sexes.M.ELD}</p>
            </div>

            <div className="bg-pink-50 rounded-xl p-3 text-center">
              <p className="text-xs font-bold text-pink-700 uppercase mb-2">Femme</p>
              <p className="text-xl font-black text-slate-800">{stats.sexes.F.FONCTIONNAIRE}</p>
              <p className="text-xl font-black text-slate.800">{stats.sexes.F.EFA}</p>
              <p className="text-xl font-black text-slate-800">{stats.sexes.F.ELD}</p>
            </div>

          </div>
        </div>

        {/* Statut marital */}
        <div className="bg-white rounded-2xl p-5 border border-slate-200">
          <p className="text-xs font-bold text-slate-500 uppercase tracking-widest mb-4">Statut marital</p>
          <div className="grid grid-cols-3 gap-2 text-center text-xs font-bold text-slate-500 uppercase mb-2">
            <span>Statut</span><span className="text-blue-700">Homme</span><span className="text-pink-700">Femme</span>
          </div>

          <div className="flex flex-col gap-2">

            <div className="grid grid-cols-3 gap-2 bg-green-50 rounded-xl px-3 py-2 items-center">
              <span className="text-xs font-bold text-green-700">Marié</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.MARIE.M}</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.MARIE.F}</span>
            </div>

            <div className="grid grid-cols-3 gap-2 bg-orange-50 rounded-xl px-3 py-2 items-center">
              <span className="text-xs font-bold text-orange-700">Célibataire</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.CELIBATAIRE.M}</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.CELIBATAIRE.F}</span>
            </div>

            <div className="grid grid-cols-3 gap-2 bg-red-50 rounded-xl px-3 py-2 items-center">
              <span className="text-xs font-bold text-red-700">Divorcé</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.DIVORCE.M}</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.DIVORCE.F}</span>
            </div>

            <div className="grid grid-cols-3 gap-2 bg-slate-50 rounded-xl px-3 py-2 items-center">
              <span className="text-xs font-bold text-slate-600">Veuf(ve)</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.VEUF.M}</span>
              <span className="text-center text-lg font-black text-slate-800">{stats.maritalStatus.VEUF.F}</span>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;